import { render } from "./card_ReceiptModal.vue?vue&type=template&id=49a54f0f&bindings={\"content\":\"props\",\"language\":\"setup\",\"lang\":\"data\",\"isLoading\":\"data\",\"close\":\"options\"}"
import script from "./card_ReceiptModal.vue?vue&type=script&lang=js"
export * from "./card_ReceiptModal.vue?vue&type=script&lang=js"

import "./card_ReceiptModal.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script